import React from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const StyledButton = styled(Button)((_theme) => ({
    'backgroundColor': '#EA3223',
    'color': 'white',
    'padding': '6px 16px',
    'boxShadow': '0px 0px 1px rgba(0, 0, 0,0.41), 2px 2px 3px rgba(0, 0, 0, 0.15)',
    '&:hover': {
        backgroundColor: '#943220',
        boxShadow: '0px 0px 4px rgba(0, 0, 0,0.41), 2px 2px 3px rgba(0, 0, 0, 0.15)',
    },
}));

const CancelButton = (props) => {
    const { title, onClick } = props;

    return (
        <StyledButton
            color="primary"
            onClick={onClick}
        >
            {title}
        </StyledButton>
    );
};

CancelButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
};

export default CancelButton;
